import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import AdHocReport from './AdhocReport'
import AdhocDbReportProcess from './AdhocReportProcess'
import Dashboard from './Dashboard'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import CompletedReports from './CompletedReports'
import WindReport from '../wind/WindReport'
import ReportDashboard from 'report-dashboard'
import RptPerfmReportScreen from './RptPerfmReportScreen'
import EventDashboard from 'event-dashboard'
import SRPEventDashboard from 'event-dashboard/SRPEventDashboard'

const ReportContainer = ({ actionPermits, envConfig }) => {
  const hasReport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.REPORT_ACCESS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasCompletedReport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.REPORT_ACCESS,
          ScreenPermissions.REPORT_ADHOCK_ACCESS_PDF,
          ScreenPermissions.REPORT_ADHOCK_ACCESS_EXCEL,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasAdhoc = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.REPORT_ADHOCK_ACCESS_PDF,
          ScreenPermissions.REPORT_ADHOCK_ACCESS_EXCEL,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasAdhocProcess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.REPORT_ADHOC_PROCESS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasWindAdhoc = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADHOC_MATRIX_REPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  // below report created by Prakash
  const hasReportDashboardAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.REPORT_DASHBOARD_ACCESS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const performanceOveride = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.REPORT_PERFORMANCE_MEASURES_ADMIN,
          ScreenPermissions.REPORT_PERFORMANCE_MEASURES_VIEW,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasEventDashboard = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.EVENT_DASHBOARD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasSRPEventDashboard = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.SRP_EVENT_DASHBOARD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <>
      {hasEventDashboard && (
        <Route
          exact
          key="event-dashboard-report"
          path="/event-dashboard-report"
          component={EventDashboard}
        />
      )}
      {hasSRPEventDashboard && (
        <Route
          exact
          key="srp-event-dashboard-report"
          path="/srp-event-dashboard-report"
          component={SRPEventDashboard}
        />
      )}
      {hasReportDashboardAccess && (
        <Route
          exact
          key="report-dashboard"
          path="/report-dashboard"
          component={ReportDashboard}
        />
      )}
      {hasReport && <Route exact path="/reportantd" component={Dashboard} />}
      {hasCompletedReport && (
        <Route exact path="/completedreports" component={CompletedReports} />
      )}
      {hasAdhoc && <Route exact path="/adhoc-report" component={AdHocReport} />}
      {hasAdhocProcess && (
        <Route
          exact
          path="/adhoc-report-process"
          component={AdhocDbReportProcess}
        />
      )}
      {hasWindAdhoc && <Route exact path="/windadhoc" component={WindReport} />}
      {performanceOveride && (
        <Route
          exact
          path="/performance-override"
          component={RptPerfmReportScreen}
        />
      )}
    </>
  )
}

export default ReportContainer
